<section class="usuario-shell">
	<header class="usuario-hero">
		<div>
			<h2 class="usuario-title">Atualizar Cadastro do Usuário</h2>
			<p class="usuario-subtitle">Mantenha seus dados de acesso e informações de perfil sempre atualizados.</p>
		</div>
		<span class="usuario-chip">Perfil Logado</span>
	</header>

	<form [formGroup]="usuarioForm" class="usuario-card">
		<div class="form-section">
			<h3>Dados de Acesso</h3>
			<div class="row g-3">
				<div class="col-md-2">
					<label for="id" class="form-label">ID</label>
					<input id="id" type="text" class="form-control bg-light" formControlName="id" readonly>
				</div>

				<div class="col-md-4">
					<label for="nomeUsuario" class="form-label">Nome de Usuário</label>
					<input id="nomeUsuario" type="text" class="form-control bg-light" formControlName="nomeUsuario"
								 [class.is-invalid]="usuarioForm.get('nomeUsuario')?.invalid && usuarioForm.get('nomeUsuario')?.touched">
				</div>

				<div class="col-md-6">
					<label for="nomeCompleto" class="form-label">Nome Completo</label>
					<input id="nomeCompleto" type="text" class="form-control" formControlName="nomeCompleto"
								 [class.is-invalid]="usuarioForm.get('nomeCompleto')?.invalid && usuarioForm.get('nomeCompleto')?.touched">
				</div>

				<div class="col-md-6">
					<label for="email" class="form-label">E-mail</label>
					<input id="email" type="email" class="form-control bg-light" formControlName="email"
								 [class.is-invalid]="usuarioForm.get('email')?.invalid && usuarioForm.get('email')?.touched">
				</div>

				<div class="col-md-3 d-flex align-items-end">
					<div class="form-check form-switch mb-2">
						<input id="ativo" class="form-check-input" type="checkbox" formControlName="ativo">
						<label class="form-check-label" for="ativo">Usuário Ativo</label>
					</div>
				</div>
			</div>
		</div>

		<div class="form-section">
			<h3>Segurança</h3>
			<div class="row g-3">
				<div class="col-md-6">
					<label for="secret" class="form-label">Senha</label>
					<input id="secret" type="password" class="form-control" formControlName="secret"
								 [class.is-invalid]="usuarioForm.get('secret')?.invalid && usuarioForm.get('secret')?.touched">
				</div>

				<div class="col-md-6">
					<label for="confirmarSenha" class="form-label">Confirmar Senha</label>
					<input id="confirmarSenha" type="password" class="form-control" formControlName="confirmarSenha"
								 [class.is-invalid]="usuarioForm.get('confirmarSenha')?.touched && (!senhasConferem || usuarioForm.get('confirmarSenha')?.invalid)">
					<div class="invalid-feedback d-block" *ngIf="usuarioForm.get('confirmarSenha')?.touched && !senhasConferem">
						As senhas precisam ser iguais.
					</div>
				</div>
			</div>
		</div>
	</form>

	<footer class="action-bar">
		<button type="button" class="btn btn-outline-secondary" (click)="voltar()" [disabled]="isLoading">
			Cancelar
		</button>
		<button type="button" class="btn btn-primary" (click)="salvar()" [disabled]="isLoading || usuarioForm.invalid || !senhasConferem">
			{{ isLoading ? 'Salvando...' : 'Salvar Alterações' }}
		</button>
	</footer>
</section>
